// Area Navigation component
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { RoadIcon } from '@moia-dev/pace-icons'
import { RoadNetworkAreaRoutes } from './RoadNetworkAreaRoutes'

export const RoadNetworkAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={RoadNetworkAreaRoutes.route}
      Icon={RoadIcon}
    />
  )
}
